import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useSelector } from '@grandvisionhq/state';
import { FrameInformation as FrameInformation$1 } from './FrameInformation.js';
import { getSelectedFrame, getFrameImage } from '../../../../state/configurator/selectors.js';

const FrameInformationContainer = (props)=>{
    const frame = useSelector(getSelectedFrame);
    const image = useSelector((s)=>getFrameImage(s, {
            width: 100
        })
    );
    if (!frame) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FrameInformation$1, swcHelpers.extends({}, props, {
        title: frame.brand,
        subtitle: frame.code,
        imageUrl: image === null || image === void 0 ? void 0 : image.url
    }));
};
var FrameInformation = FrameInformationContainer;

export { FrameInformation as default };
//# sourceMappingURL=FrameInformationContainer.js.map
